import React, { useContext } from "react";
import { Card, Col, Row } from "react-bootstrap";

import PsContext from "../../context";
import Header from "../header";
import ModuleAccess from "../../context/moduleAccess";
import AttendanceList from "./attendanceList";
import MyAbsentDays from "./myAbsentDays";

const Attendance = (props) => {
  const context = useContext(PsContext);

  return (
    <>
      <Header title="Attendance" backAction={[]} />
      <div data-aos="zoom-in">
        <div className="container-sm py-md-3">
          <Row>
            <Col md={12} className="mb-3">
              <Card>
                <Card.Header className="card-header-bg text-uppercase fw-bold">
                  Today Attendance
                </Card.Header>
                <Card.Body>
                  <AttendanceList />
                </Card.Body>
              </Card>
            </Col>

            <ModuleAccess
              module="stu_mob_absent_days_list"
              action="action_list"
            >
              <Col md={6} className="mb-3">
                <MyAbsentDays type="absent" />
              </Col>
            </ModuleAccess>

            <ModuleAccess module="stu_mob_od_list" action="action_list">
              <Col md={6} className="mb-3">
                <MyAbsentDays type="od" />
              </Col>
            </ModuleAccess>
          </Row>
        </div>

        <div className="my-5"></div>
      </div>
    </>
  );
};
export default Attendance;
